<div class="col-2">
    <bpt-dropdown label="Users" [options]="userList" [editable]="false"
    placeholder="Select User" id="CreateChangeRequestItemAdditionalNotifiedUsers"
    [showClear]="false" [showFilter]="true" [multiSelect]="false" [valueField]="valueField"
    [labelField]="labelField" [(ngModel)]="loggedInUser" (dropdownChange)="setUserPUID()">
</bpt-dropdown>
</div>
